import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

type SearchSchema = {
  status?: string
  bucket?: string
  query?: string
  page?: number
  pageSize?: number
}

export function EventListPagination({
  safePage,
  pageCount,
  totalCount,
  onNavigate,
}: {
  safePage: number
  pageCount: number
  totalCount: number
  onNavigate: (updater: (prev: SearchSchema) => Partial<SearchSchema>) => void
}) {
  return (
    <div className="mt-4 flex items-center justify-between">
      <div className="text-xs text-muted-foreground">
        Page {safePage} of {pageCount} ({totalCount} total)
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={safePage <= 1}
          onClick={() => {
            onNavigate((prev) => ({
              ...prev,
              page: Math.max(1, safePage - 1),
            }))
          }}
        >
          Previous
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={safePage >= pageCount}
          onClick={() => {
            onNavigate((prev) => ({
              ...prev,
              page: Math.min(pageCount, safePage + 1),
            }))
          }}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
